// currently unused because of no favourites page in live-casino
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useIsFavouriteGamesEnabled } from '../../useIsFavouriteGamesEnabled';
import { isLoggedInSelector } from '../../../redux/reducers/app/params';
import { NAVBAR_ITEMS, ROUTES_WITH_FAVORITES } from '../../../constants/navbar';

const HIDE_FAVOURITE_BUTTON_EVENT = {
  item: NAVBAR_ITEMS.FAVORITES,
  itemConfig: {
    enabled: false,
  },
};

const SHOW_FAVOURITE_BUTTON_EVENT = {
  item: NAVBAR_ITEMS.FAVORITES,
  itemConfig: {
    route: {
      type: 'CASINO',
      params: {
        service: `live-casino/favourites`,
      },
    },
  },
};
export const useNavbarFavoriteButton = () => {
  const { path } = useRouteMatch();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const isFavoriteFeatureEnabled = useIsFavouriteGamesEnabled();
  const areFavouritesEnabled = isFavoriteFeatureEnabled && isLoggedIn;

  return useMemo(() => {
    if (!areFavouritesEnabled) {
      return HIDE_FAVOURITE_BUTTON_EVENT;
    }

    return ROUTES_WITH_FAVORITES.includes(path)
      ? SHOW_FAVOURITE_BUTTON_EVENT
      : null;
  }, [areFavouritesEnabled, path]);
};
